import { search } from "../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/faturamento/tag/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findTag({ empresa_cnpj, id, orderByColumn }) {
  return search(
    `${path}${id ? `/${id}` : ""}?empresa_cnpj=${empresa_cnpj}${
      orderByColumn ? "&sort=" + orderByColumn + "+" : ""
    }`,
    "GET",
    headers
  );
}

export async function searchByType({ body, empresa_cnpj }) {
  return search(
    `${path}/por-tipo?empresa_cnpj=${empresa_cnpj}`,
    "POST",
    headers,
    body
  );
}
